














































import { Component, Mixins } from 'vue-property-decorator';
import { Mutations, Actions, Buttons } from '@/ts/store/Constants';
import DeviceMethods from '@/mixins/DeviceMethods.vue';
import MessageMethods from '@/mixins/MessageMethods.vue';
import StaffConversations from '@/components/Messages/StaffConversations.vue';
import ConversationData from '@/ts/ConversationData';
import MessageData from '@/ts/MessageData';
import { saveScroll, setScroll } from '@/plugins/save-position';

import { Keyboard, KeyboardInfo } from '@capacitor/keyboard';

@Component({
    components: {
        StaffConversations,
    },
})
export default class UserInbox extends Mixins(DeviceMethods, MessageMethods) {
    public staffMessagesId: string = 'hoc-adminapp-inbox';

    public conversationSearch: string = '';
    private keyboardListenerAdded: boolean = false;

    constructor() {
        super();
        this.initializeKeyboardListener();
    }

    public initializeKeyboardListener(): void {
        if (this.keyboardListenerAdded === true) {
            return;
        }

        if (this.$store.state.Viewport.deviceInfo.platform === 'web') {
            this.keyboardListenerAdded = true;
            return;
        }

        Keyboard.addListener('keyboardDidShow', (info: KeyboardInfo) => {
            this.$store.commit(Mutations.SET_INDEX_PAGES_KEYBOARD_VISIBILITY, true);
        });

        Keyboard.addListener('keyboardDidHide', () => {
            this.$store.commit(Mutations.SET_INDEX_PAGES_KEYBOARD_VISIBILITY, false);
        });

        this.keyboardListenerAdded = true;
    }

    get conversations() {
        if (this.conversationSearch.trim() !== '') {
            return this.$store.getters['Messages/conversationList'].filter((conversation: ConversationData) => {
                if (conversation.lastMessage === null) {
                    return false;
                }

                const lastMessageText = (typeof conversation.lastMessage.message !== 'undefined')
                    ? conversation.lastMessage.message
                    : '';

                const lastMessageAuthor = (typeof conversation.lastMessage.authorId !== 'undefined')
                    ? this.sender(conversation.lastMessage)
                    : '';

                return conversation.lastMessage.message.toLowerCase().includes(this.conversationSearch.toLowerCase())
                    || lastMessageAuthor.firstName.toLowerCase().includes(this.conversationSearch.toLowerCase())
                    || lastMessageAuthor.familyName.toLowerCase().includes(this.conversationSearch.toLowerCase());
            });
        }

        return this.$store.getters['Messages/conversationList'];
    }

    get activeConversationType() {
        return this.$store.getters['Messages/getVisibleConversationsStatus'];
    }

    public changeConversationStatus(type: string) {
        this.$store.commit(Mutations.SET_VISIBLE_CONVERSATIONS_STATUS, type);
    }

    public sender(message: MessageData) {
        return this.$store.getters['User/getCacheUser'](message.authorId);
    }

    public goToInboxChat(conversation: ConversationData) {
        this.$store.commit(Mutations.UPDATE_ACTIVE_CONVERSATION, conversation.id);
        this.$store.commit(Mutations.SET_STAFF_PROPERTY_ICON_LINK, conversation.propertyId);

        if (conversation.hasUnseenMessages === true) {
            this.$store.dispatch(Actions.MARK_ACTIVE_CONVERSATION_AS_SEEN);
        }

        this.$router.push({ path: `/user/inbox/${conversation.id}` });
    }

    public beforeCreate() {
        this.$store.commit(Mutations.SET_HEADER_TEXT, this.$t('header.inbox', 'Inbox'));
        this.$store.commit(Mutations.SET_LEFT_HEADER_BUTTON, Buttons.StaffLanguageButton);
        this.$store.commit(Mutations.SET_RIGHT_HEADER_BUTTON, Buttons.UserProfileButton);
        this.$store.commit(Mutations.SET_BOTTOM_MENU_VISIBILITY, true);
    }

    public mounted() {
        setScroll(this.staffMessagesId, 'getStaffAppPagePosition');
    }

    public beforeRouteLeave(to, from, next) {
        saveScroll(this.staffMessagesId, Mutations.SET_STAFF_APP_PAGE_SCROLL_POSITION);
        next();
    }
}
